import { Link } from '@mui/material';
import { Fragment, ReactNode } from 'react';

interface NoteContentProps {
  content: string;
}

const getSafeHref = (href: string) => {
  try {
    const url = new URL(href, window.location.origin);
    return ['http:', 'https:', 'mailto:'].includes(url.protocol) ? href : null;
  } catch {
    return null;
  }
};

const renderNode = (node: ChildNode, key: number): ReactNode => {
  if (node.nodeType === Node.TEXT_NODE) {
    return node.textContent;
  }
  if (!(node instanceof HTMLElement)) return null;

  const children = Array.from(node.childNodes).map(renderNode);

  if (node.tagName === 'A') {
    const href = getSafeHref(node.getAttribute('href') || '');
    if (href) {
      return (
        <Link key={key} href={href} target='_blank' rel='noopener noreferrer'>
          {children}
        </Link>
      );
    }
  }

  return <Fragment key={key}>{children}</Fragment>;
};

function NoteContent({ content }: NoteContentProps) {
  const document = new DOMParser().parseFromString(content, 'text/html');
  return <>{Array.from(document.body.childNodes).map(renderNode)}</>;
}

export default NoteContent;
